'use client'
import { useState, useEffect } from 'react'
import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import BlueHero from '@/components/BlueHero'
import { getBusinessesPage, getLatestBlogs } from '@/lib/api'

// Client component to fetch businesses and show countdown
export default function BusinessPage() {
  const [pageData, setPageData] = useState<any>(null)
  const [blogs, setBlogs] = useState<any[]>([])
  const [time, setTime] = useState({ d: 4, h: 23, m: 42, s: 12 })

  useEffect(() => {
    Promise.all([getBusinessesPage(), getLatestBlogs()]).then(([biz, bl]) => {
      setPageData(biz)
      setBlogs((bl || []).slice(0, 3))
    })
  }, [])

  useEffect(() => {
    const t = setInterval(() => {
      setTime(prev => {
        let { d, h, m, s } = prev
        s--; if (s < 0) { s = 59; m-- }
        if (m < 0) { m = 59; h-- }
        if (h < 0) { h = 23; d-- }
        if (d < 0) { d = 0; h = 0; m = 0; s = 0 }
        return { d, h, m, s }
      })
    }, 1000)
    return () => clearInterval(t)
  }, [])

  const pad = (n: number) => String(n).padStart(2, '0')
  const comingSoon = (pageData?.coming_soon_projects || []).slice(0, 2)
  const current = (pageData?.current_projects || []).slice(0, 2)

  const fallbackBlogs = [
    { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-homs.jpg', date: '04/08/2024', category: 'Travel', likes: 23, comments: 5 },
    { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-steve-jobs.jpg', date: '04/08/2024', category: 'Travel', likes: 23, comments: 5 },
    { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/investment-wealth.jpg', date: '04/08/2024', category: 'Travel', likes: 23, comments: 5 },
  ]

  return (
    <>
      <BlueHero title="BUSINESS" />

      {/* FROM VISIONARY */}
      <section style={{ background: '#07090e', padding: '64px 0 48px' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto', padding: '0 32px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 900, color: '#fff', letterSpacing: '0.06em', marginBottom: '16px' }}>FROM VISIONARY BEGINNINGS TO BUSINESS INNOVATION</h2>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.85, marginBottom: '40px' }}>
            Learn About The Key Qualities That Make A Venture Partner Successful. Effective Partnerships Are Built On Traits That Lead To Success And Good Collaboration.
          </p>
          <div style={{ maxWidth: '340px', margin: '0 auto' }}>
            <p style={{ fontSize: '13px', fontWeight: 700, color: '#f97316', letterSpacing: '0.06em', marginBottom: '6px' }}>MEET US AT WORLDEF DUBAI BLOCK C17</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: '14px' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>
              <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.65)' }}>{time.d} Days Left &amp; {pad(time.h)}h : {pad(time.m)}m : {pad(time.s)}s</span>
            </div>
            <div style={{ background: '#fff', borderRadius: '6px', overflow: 'hidden' }}>
              <div style={{ padding: '22px 20px 18px', textAlign: 'center' }}>
                <div style={{ fontSize: '30px', fontWeight: 900, letterSpacing: '-1px', color: '#0f1830', display: 'inline-flex', alignItems: 'center', gap: '1px' }}>
                  <span>W</span>
                  <span style={{ width: '22px', height: '22px', borderRadius: '50%', border: '3px solid #1e63d6', display: 'inline-block', position: 'relative', top: '1px' }} />
                  <span>RLDEF</span>
                </div>
                <div style={{ display: 'flex', gap: '6px', justifyContent: 'center', alignItems: 'center', marginTop: '8px', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '8.5px', fontWeight: 700, color: '#1e63d6', border: '1px solid #1e63d6', borderRadius: '3px', padding: '2px 6px' }}>Dubai CommerCity</span>
                  <span style={{ fontSize: '8.5px', fontWeight: 800, color: '#fff', background: '#0f1830', borderRadius: '3px', padding: '2px 8px', letterSpacing: '0.08em' }}>DUBAI</span>
                  <span style={{ fontSize: '8.5px', fontWeight: 700, color: '#444', border: '1px solid #ccc', borderRadius: '3px', padding: '2px 6px' }}>DEC 4-6, 26</span>
                </div>
                <div style={{ fontSize: '8px', color: '#999', marginTop: '8px', letterSpacing: '0.04em' }}>In partnership with <strong style={{ color: '#1e63d6' }}>COMMERCITY</strong></div>
              </div>
              <div style={{ background: '#111', padding: '10px', textAlign: 'center' }}>
                <span style={{ fontSize: '11px', fontWeight: 700, color: '#fff', letterSpacing: '0.08em' }}>SOMETHING BIG IS COMING <span style={{ color: '#f97316' }}>SOON...</span></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COMING SOON */}
      <section style={{ background: '#07090e', padding: '48px 0' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '10px' }}>Coming Soon Projects</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.52)', textAlign: 'center', lineHeight: 1.85, marginBottom: '32px' }}>At Mohammad Ghassan Alfifai, The Focus Is On New And Exciting Projects That Will Be Revealed Soon, Aiming To Create Solutions For The Future.</p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', maxWidth: '560px', margin: '0 auto' }}>
            {(comingSoon.length > 0 ? comingSoon : [
              { id: 1, title: 'Treasure Deal Invest', logo: '/treasure-deal-invest.svg' },
              { id: 2, title: 'Treasure Deal Group', logo: '/treasure-deal-group.svg' },
            ]).map((p: any, i: number) => (
              <div key={p.id || i} style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(20,40,120,0.7)' }}>
                <div style={{ background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100px', padding: '14px' }}>
                  <img src={p.logo || p.image || '/placeholder-logo.png'} alt={p.title} style={{ maxHeight: '64px', maxWidth: '100%', objectFit: 'contain' }} onError={(e:any)=>{e.currentTarget.src='/placeholder-logo.png'}} />
                </div>
                <div style={{ background: 'rgba(8,16,55,0.9)', padding: '10px 14px' }}>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: '#fff', marginBottom: '2px' }}>{p.title}</div>
                  <div style={{ fontSize: '10.5px', color: 'rgba(255,255,255,0.40)', lineHeight: 1.5 }}>By<br />{p.created_by || 'Mr. Mohammad Ghassan A Al Rifai'}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CURRENT PROJECTS */}
      <section style={{ background: '#07090e', padding: '32px 0 64px' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '32px' }}>Current Projects</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', maxWidth: '560px', margin: '0 auto' }}>
            {(current.length > 0 ? current : [
              { id: 1, title: 'Veteran General Contracting', image: '/veteran-logo.svg' },
              { id: 2, title: 'Zenith Digital Egency', image: '/zenith-logo.svg' },
            ]).map((p: any, i: number) => (
              <div key={p.id || i} style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(20,40,120,0.7)' }}>
                <div style={{ background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100px', padding: '14px' }}>
                  <img src={p.logo || p.image || '/placeholder-logo.png'} alt={p.title} style={{ maxHeight: '64px', maxWidth: '100%', objectFit: 'contain' }} onError={(e:any)=>{e.currentTarget.src='/placeholder-logo.png'}} />
                </div>
                <div style={{ background: 'rgba(8,16,55,0.9)', padding: '10px 14px' }}>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: '#fff', marginBottom: '2px' }}>{p.title}</div>
                  <div style={{ fontSize: '10.5px', color: 'rgba(255,255,255,0.40)', lineHeight: 1.5 }}>By<br />{p.created_by || 'Mr. Mohammad Ghassan A Al Rifai'}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BLOG */}
      <section className="relative overflow-hidden" style={{ background: '#161920', padding: '64px 0' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'url(/arab-pattern-bg.jpg)', backgroundSize: 'cover', opacity: 0.07, zIndex: 0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'rgba(16,18,26,0.80)', zIndex: 0 }} />
        <div className="relative z-10" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '10px' }}>From His Blog</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.85, maxWidth: '520px', margin: '0 auto 40px' }}>
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects. Stay Updated With Content Relevant To You.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '18px' }}>
            {(blogs.length > 0 ? blogs : fallbackBlogs).map((post: any) => (
              <BlogCard key={post.id} id={String(post.id)} title={post.title} image={post.image} date={post.created_at || post.date} category={post.category || ''} likes={post.likes_count ?? post.likes ?? 0} comments={post.comments_count ?? post.comments ?? 0} />
            ))}
          </div>
        </div>
      </section>

      <NewsletterSection />
    </>
  )
}
